































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import HasValidation from "@/mixins/HasValidation";

// Data
import { CustomFields } from "@/data/status";

// Enums
import { DataModules, DEFAULT_LIST_SCOPE } from "@/store/modules/data";
import { ActionTypes } from "@/data/enums";
import {
  CustomFieldsMajorTypes,
  CustomFieldsTypes
} from "@/data/enums/customFields";
import { TranslationsTypes } from "@/data/enums/translations";

// Types
import { IBrand, ICustomField } from "@/models/brands";
import { ICustomFieldsForm } from "@/models/brands";
import { IState } from "@/store";
import { AxiosError } from "axios";

@Component({
  components: {
    "custom-fields-options": () =>
      import(
        "@/components/app/admin/settings/brands/customFieldsOptionsList.vue"
      )
  },
  computed: {
    ...mapState({
      customField(state: IState, getters) {
        return getters[`data/single`]({
          storeModule: this.dataModule,
          scope: this.customFieldScope
        });
      },
      customFieldScope(state: IState, getters) {
        return getters[`data/${this.dataModule}/scope`](this.customFieldId);
      },
      brandId(state: IState) {
        return state.auth.admin.brandId;
      }
    })
  }
})
export default class ManageCustomFieldModal extends Mixins(
  RequestPromises,
  HasValidation
) {
  // State
  public customField!: ICustomField;
  public customFieldTypes = CustomFieldsTypes;
  public customFieldScope!: string;
  public brandId!: IBrand["id"];

  // Prop
  @Prop({ default: ActionTypes.CREATE })
  public actionType!: ActionTypes;

  @Prop({ default: CustomFieldsMajorTypes.CLIENT })
  public customFieldType!: string;

  @Prop({ default: "" })
  public customFieldId!: ICustomField["id"];

  // Variables
  public isLoading = false;
  public isReloading = false;
  public isProcessing = false;
  public requestError = false;

  public customFieldsTypes: any = this.$_.clone(CustomFields);
  public customFieldsOptions: any[] = [];
  public customFieldsMajorTypes = CustomFieldsMajorTypes;

  public form: ICustomFieldsForm = {
    type: CustomFieldsTypes.TEXT,
    name: "",
    required: true,
    user_only: false,
    show_on_order_form: true,
    show_on_invoice: true,
    values: []
  };
  public formClone: ICustomFieldsForm | any = {};

  public created() {
    if (this.actionType === ActionTypes.UPDATE) {
      this.isLoading = true;
      this.loadData();
    }
  }

  public async loadData() {
    try {
      await this.getCustomFieldData();
      this.fillForm();
      this.requestError = false;
    } catch (error) {
      this.$buefy.toast.open({
        message: (error as AxiosError).message,
        type: "is-danger"
      });
      this.requestError = true;
    }
    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public fillForm() {
    if (this.actionType === ActionTypes.UPDATE) {
      this.form = this.$_.merge(
        this.form,
        this.$_.pick(this.customField, this.$_.keys(this.form))
      );
      if (this.form.values === null) {
        this.form.values = [];
      }
      this.formClone = this.$_.cloneDeep(this.form);
    }
  }

  public getCustomFieldData() {
    return this.$store.dispatch(`data/${this.dataModule}/get`, {
      id: this.customFieldId,
      scope: this.customFieldScope,
      vm: this
    });
  }

  public get dataModule() {
    return this.customFieldType === CustomFieldsMajorTypes.CLIENT
      ? DataModules.CUSTOM_FIELDS_CLIENTS
      : DataModules.CUSTOM_FIELDS_BASKET;
  }

  public validateBeforeSubmit() {
    this.isProcessing = true;
    this.validate()
      .then(result => {
        if (result) {
          return this.actionType === ActionTypes.CREATE
            ? this.createCustomField()
            : this.updateCustomField();
        }
        throw this.$t("_sentence.form_is_not_valid");
      })
      .then(() => {
        this.$buefy.toast.open({
          message: this.$t(
            `_.object_successfully_${
              this.actionType === ActionTypes.CREATE ? "added" : "updated"
            }`,
            { object: this.$t("_.custom_field") }
          ) as string
        });

        this.$emit("close");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => {
        this.isProcessing = false;
      });
  }

  public get formIsValid() {
    if (
      this.form.type === CustomFieldsTypes.SELECT &&
      (!this.form.values.length ||
        !!this.$_.find(this.$_.get(this.form, "values", []), option => {
          return this.$_.isEmpty(option.label);
        }))
    ) {
      return false;
    }

    if (this.$_.isEmpty(this.form.name)) {
      return false;
    }

    if (
      this.actionType === ActionTypes.UPDATE &&
      this.$_.isEqual(this.form, this.formClone)
    ) {
      return false;
    }

    return true;
  }

  public onTypeChange(type: CustomFieldsTypes) {
    this.customFieldsOptions = [];
    this.form.values = [];
    if (type === CustomFieldsTypes.PASSWORD) {
      this.form.show_on_invoice = false;
    }
  }

  public get formIsDisabled() {
    return (
      this.isProcessing ||
      this.isLoading ||
      this.isReloading ||
      !this.formIsValid ||
      this.hasErrors
    );
  }

  public createCustomField() {
    return this.$store.dispatch(`data/${this.dataModule}/create`, {
      data: this.form
    });
  }

  public updateCustomField() {
    return this.$store.dispatch(`data/${this.dataModule}/update`, {
      id: this.customFieldId,
      scope: DEFAULT_LIST_SCOPE,
      updateStore: true,
      data: this.getNewValues()
    });
  }

  public openTranslateModal(props) {
    this.$store.dispatch(
      `data/${DataModules.TRANSLATIONS}/openTranslationsModal`,
      {
        props: {
          brandId: this.brandId,
          objectId: this.customFieldId,
          objectTypeCode:
            this.customFieldType === CustomFieldsMajorTypes.CLIENT
              ? TranslationsTypes.CLIENTS_FIELD
              : TranslationsTypes.BASKET_FIELD,
          fieldType: "text",
          ...props
        }
      }
    );
  }

  public getNewValues() {
    const newValues: any = this.$_.omitBy(this.form, (v, k) => {
      return this.formClone[k] === v;
    });

    return newValues;
  }

  public formValuesChanged(newArray: any) {
    this.form.values = newArray;
    this.form = this.$_.cloneDeep(this.form);
  }

  public onRequiredChange(value: boolean) {
    if (value) {
      this.form.show_on_order_form = true;
    }
  }

  public onUserOnlyChange(value: boolean) {
    if (value) {
      this.form.show_on_invoice = false;
    }
  }

  public get userCanManage() {
    if (this.customFieldType === CustomFieldsMajorTypes.CLIENT) {
      return this.actionType === ActionTypes.CREATE
        ? this.$userCan("create_client_field")
        : this.$userCan("update_client_field");
    }

    return this.actionType === ActionTypes.CREATE
      ? this.$userCan("create_basket_field")
      : this.$userCan("update_basket_field");
  }

  public beforeDestroy() {
    if (this.customFieldId) {
      this.$store.dispatch("data/bin", {
        storeModule: this.dataModule,
        scope: this.customFieldScope,
        vm: this
      });
    }
  }
}
